import request from '@/utils/request.js';

// 我的礼包列表
export const getMyGiftList = params =>
  request({ url: '/v1/gift_center/received', method: 'get', params });

// 礼包模块列表接口
export const giftPackagePlates = () =>
  request({ url: '/v1/api/gift_package_plates', method: 'post' });

// 礼包列表接口
export const giftPackages = data => request({ url: '/v1/api/gift_packages', method: 'post', data });

// 获取礼包广告位列表
export const getGiftBannerList = () => request({ url: '/v1/ad/gift', method: 'get' });

// 获取已激活的游戏列表
export const getActivatedGame = () =>
  request({ url: '/v1/gift_center/activated_game_list', method: 'get' });

// 获取已激活的游戏列表详情
export const getActivatedGameDetail = params =>
  request({ url: '/v1/gift_center/activated_game_info', method: 'get', params });

// 获取可配置板块列表
export const getGiftPlate = (params) => request({ url: '/v1/gift_center/gift_plate', method: 'get', params });

// 获取上新礼包列表
export const getNewGift = (params) => request({ url: '/v1/gift_center/new_gift', method: 'get', params });

// 全部礼包
export const getAllGift = params =>
  request({ url: '/v1/gift_center/gift_by_plate', method: 'get', params });
// 礼包详情
export const getGiftDetail = params =>
  request({ url: '/v1/gift_center/gift_info', method: 'get', params });
// 领取礼包
export const pickGift = data => request({ url: '/v1/gift_center/get_gift', method: 'post', data });
// 领取礼包引流信息
export const getGiftFeedbackInfo = params =>
  request({ url: '/v1/pop_up_drainage/config', method: 'get', params });

